/**
 * Shared helper for HTTP interceptors to recognize requests targeting any of
 * our configured backend hosts (not just the primary `api.baseUrl`).
 *
 * Some environments (e.g. preview) split traffic across multiple hosts —
 * `sseBaseUrl` for real-time events and `screenshotsBaseUrl` for screenshot
 * capture/serving — while `baseUrl` is temporarily pointed elsewhere. Requests
 * to those secondary hosts must still receive auth/caching treatment.
 */
import { environment } from '../../../environments/environment';

export function isConfiguredApiUrl(url: string): boolean {
    const candidates = [
        environment.api.baseUrl,
        environment.api.sseBaseUrl,
        environment.api.screenshotsBaseUrl,
    ];

    return candidates.some((base) => !!base && url.startsWith(base));
}
